/**
 * Thrown for any non-2xx response. Carries the structured error the API
 * returned so callers can branch on `code` instead of parsing messages.
 */
export class ZuruflexApiError extends Error {
    code;
    status;
    fields;
    /**
     * `error` is typed as present, but it arrives from the network and the
     * network does not read our types. Anything in front of the API — a
     * tunnel, a proxy, a load balancer — can answer with JSON that parses
     * cleanly and carries no `error` at all, and reading `.message` off that
     * threw a TypeError from inside this constructor. The result was that a
     * plain "the API is down" surfaced as `Cannot read properties of
     * undefined (reading 'message')`, pointing at the error path rather than
     * the failure, which is the worst place to lose the truth.
     */
    constructor(status, error) {
        super(error?.message ?? `Request failed with status ${status}`);
        this.name = 'ZuruflexApiError';
        this.status = status;
        this.code = error?.code ?? (status >= 500 ? 'INTERNAL_ERROR' : 'BAD_REQUEST');
        this.fields = error?.fields;
    }
    get isRetryable() {
        return this.status >= 500 || this.code === 'RATE_LIMITED';
    }
}
